module.exports = __webpack_public_path__ + "static/img/3.072f5b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/3.png
// module id = +oTD
// module chunks = 0